import { Divided } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import clsx from 'clsx';
import s from './ModalDivided.module.scss';

type DividedProps = Parameters<typeof Divided>[0];

export function ModalDivided({ className, ...props }: DividedProps): ReactNode {
    return <Divided {...props} className={clsx(s.modalDivided, className)} />;
}
